import { render, staticRenderFns } from "./BacMultiselectWrapper.vue?vue&type=template&id=5b882c6c&"
var script = {}
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./BacMultiselectWrapper.vue?vue&type=style&index=1&id=5b882c6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports